import { render, staticRenderFns } from "./ApprovedCampaigns.vue?vue&type=template&id=ffc19630&"
import script from "./ApprovedCampaigns.vue?vue&type=script&lang=ts&"
export * from "./ApprovedCampaigns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports